import { useMemo } from 'react';
import { useAppSelector } from '../redux';

const useLayerCount = () => {
  const { dynamicStyleIds, staticStyleIds } = useAppSelector(state => ({
    dynamicStyleIds: state.map.dynamicStyleIds,
    staticStyleIds: state.map.staticStyleIds
  }));

  return useMemo(() => {
    let total = dynamicStyleIds.length + staticStyleIds.length;
    // Ground conditions auto-applies surface type and can't be removed, so count them as one
    if (dynamicStyleIds.includes('groundConditions') && dynamicStyleIds.includes('surfaceType')) {
      total -= 1;
    }
    return total;
  }, [dynamicStyleIds, staticStyleIds]);
};

export default useLayerCount;
